module.exports = __webpack_public_path__ + "058b56b941dcaa679ae65bec1d7b0d78.png";